import React from 'react';
import ENUMS from '../../enums/index';
import AddOrEditRegion from '../../screens/citiesAndRegions/addOrEditRegion/AddOrEditRegion';

export const regionsListColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام منطقه',
    dataIndex: 'name',
    name: 'name',
    isSortable: true,
  },
  {
    title: 'ویرایش',
    dataIndex: '',
    name: '',
    isSortable: false,
    permission: ENUMS.PERMISSIONS.values.EDIT_REGION,
    action: item => (
      <AddOrEditRegion editMode={true} item={item} />
    ),
  },
];